import { render, staticRenderFns } from "./ReciprocityVisa.vue?vue&type=template&id=6e646348&"
import script from "./ReciprocityVisa.vue?vue&type=script&lang=js&"
export * from "./ReciprocityVisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports